/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- STACKED CHARTS : STYLES --------------- ++++++++++ */
export default {
    stackedcharts: {
        width: '100%',
        background: theme.color.light.light.swatch,
        transition: 'all .2s ease-in 0s',
        height: pxToEm(440),
        marginBottom: pxToEm(8),
        '& .data': {
            width: '100%',
            height: pxToEm(340), //pxToEm(240),
            display: 'flex',
            flexDirection: 'column',
            // '& .visualization': {
            //     height: pxToEm(80), // make sure parent container have a defined height when using responsive component,
            //     width: '100%',
            //     // maxWidth: pxToEm(1000),
            //     position: 'relative',
            //     '& text':{
            //         fill: 'rgb(192, 201, 220) !important'
            //     },
            //     '&:last-child': {
            //         height: pxToEm(100)
            //     }
            // },
            transition: 'filter .2s ease-in 0s'
        },
        '& .details': {
            textAlign: 'right',
            paddingTop: pxToEm(16),
            fontWeight: "500"
        },
        // ------- loading state ----------//
        '& .loading':{
            '& .name-loader':{
                height: pxToEm(16),
                width: pxToEm(16),
                paddingBottom: pxToEm(20),
                '& div':{
                    borderColor: `${theme.color.primary.medium.swatch} transparent transparent transparent`,
                    borderWidth: pxToEm(2),
                    height: pxToEm(16),
                    width: pxToEm(16)
                }
            }
        }
    }
};
